import { ApplicationController } from "../support/application-controller";

const SUCCESS_FEEDBACK_MS = 1200;

export default class extends ApplicationController {
    static targets = ["icon"];

    copy(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const value = this.data.get("value");
        if (!value) return;

        const self = this;

        if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
            navigator.clipboard.writeText(value).then(
                function () { self.showSuccessFeedback(); },
                function () { self.copyViaTextarea(value); }
            );
        } else {
            this.copyViaTextarea(value);
        }
    }

    copyViaTextarea(value) {
        const el = document.createElement("textarea");
        el.value = value;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        this.element.appendChild(el);
        el.select();
        try {
            document.execCommand("copy");
            this.showSuccessFeedback();
        } finally {
            this.element.removeChild(el);
        }
    }

    showSuccessFeedback() {
        if (!this.hasIconTarget) return;
        const icon = this.iconTarget;
        const originalText = icon.textContent;
        icon.textContent = "check";
        icon.classList.add("copy-to-clipboard__icon--copied");

        setTimeout(function () {
            icon.textContent = originalText;
            icon.classList.remove("copy-to-clipboard__icon--copied");
        }, SUCCESS_FEEDBACK_MS);
    }
}
